import {
  SalaryDiscrepancyFixability,
  SalaryDiscrepancyReason,
  SalaryDiscrepancyView,
  SalaryReconciliationUncheckedReason,
  SalaryReportRowStatus,
} from 'app/types/salaryReconciliations';

export type ReconciliationType = 'deductions' | 'salary';

export const RECONCILIATION_TYPE_PARAM = 'type';

export const ReconciliationTypeOptions: { value: ReconciliationType; text: string }[] = [
  { value: 'deductions', text: 'Deductions' },
  { value: 'salary', text: 'Salary accruals' },
];

export const SalaryReportRowStatusValues: Record<
  SalaryReportRowStatus,
  { color: string; value: string }
> = {
  NEW: { color: 'warning', value: 'New' },
  OPEN: { color: 'invited', value: 'Open' },
  MANUALLY_RESOLVED: { color: 'active', value: 'Fixed by hand' },
};

export const SalaryDiscrepancyReasonValues: Record<SalaryDiscrepancyReason, string> = {
  STORED_EARNINGS_STALE: 'Stored earnings out of date',
  OVER_CREDITED: 'Over-credited',
  OVER_CREDITED_AND_SPENT: 'Over-credited and spent',
  UNDER_CREDITED: 'Under-credited',
  STARTING_BALANCE_OR_CYCLE_BOUNDARY: 'Starting balance or cycle boundary',
  ODP_DISABLED_WITH_BALANCE: 'ODP off but has a balance',
  ODP_ALLOWANCE_ZERO_WITH_BALANCE: 'ODP allowance zero but has a balance',
  BALANCE_NOT_EXPECTED: 'Has a balance but should not',
  NO_WALLET: 'No wallet',
  WALLET_NOT_MATCHED: 'Wallet on file not found',
  UNCLASSIFIED: 'Unclassified',
};

export const SalaryDiscrepancyFixabilityValues: Record<
  SalaryDiscrepancyFixability,
  { color: string; value: string }
> = {
  FULLY: { color: 'active', value: 'Yes' },
  PARTIALLY: { color: 'warning', value: 'Partly' },
  NOT_FIXABLE: { color: 'left', value: 'No' },
};

export const SalaryUncheckedReasonValues: Record<SalaryReconciliationUncheckedReason, string> = {
  NOT_COMPUTABLE: 'Balance could not be computed',
  ERRORED: 'The check errored',
  COMPANY_FAILED: 'Their company failed',
};

export type SalaryReconciliationTabKey =
  | 'problems'
  | 'new'
  | 'resolved'
  | 'past'
  | 'fixed'
  | 'companies'
  | 'not-checked';

export const SalaryReconciliationTabs: { key: SalaryReconciliationTabKey; label: string }[] = [
  { key: 'problems', label: 'Problems' },
  { key: 'new', label: 'New problems' },
  { key: 'resolved', label: 'Resolved problems' },
  { key: 'past', label: 'Past, never fixed' },
  { key: 'fixed', label: 'Fixed by hand' },
  { key: 'companies', label: 'Companies' },
  { key: 'not-checked', label: 'Not checked' },
];

export type SalaryDiscrepancyTabKey = 'new' | 'resolved' | 'past' | 'fixed';

export const SalaryDiscrepancyTabViews: Record<SalaryDiscrepancyTabKey, SalaryDiscrepancyView> = {
  new: 'NEW',
  resolved: 'RESOLVED',
  past: 'EARLIER_CYCLES',
  fixed: 'MANUALLY_RESOLVED',
};
